<mat-form-field class="full-width m-b-20" appearance="outline">
  <mat-label>Search medicines or materials</mat-label>
  <input matInput [formControl]="searchControl" [matAutocomplete]="auto"
    placeholder="Enter medication name or NAPPI code">
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event.option.value)" [displayWith]="displaySearchValue">
    <mat-option *ngFor="let item of filteredResults | async" [value]="item">
      <div class="option-main">
        <span class="option-code" *ngIf="item.type === 'medication'">NAPPI: {{ item.nappiCode }}</span>
        <span class="option-code" *ngIf="item.type === 'material'">Cat: {{ item.catalogueNumber }}</span>
        <span class="option-description">{{ getDisplayText(item) }}</span>
      </div>
      <div class="option-price" *ngIf="item.singleExitPrice">
        <small>R{{ item.singleExitPrice | number:'1.2-2' }}</small>
      </div>
    </mat-option>
    <mat-option *ngIf="(filteredResults | async)?.length === 0 && searchControl.value && searchCompleted">
      No medicines or materials found.
    </mat-option>
  </mat-autocomplete>
</mat-form-field>

<mat-chip-grid #chipGrid aria-label="Consumable price overrides" class="chip-grid">
  <mat-chip-row *ngFor="let chip of chips; let i = index" (removed)="removeChip(i)"
    appTouchEdit (dblclick)="openEditPriceDialog(chip, i)" class="editable-chip" [matTooltip]="getChipTooltip(chip)">
    <span class="chip-label">{{ chip.code }} - {{ truncateDescription(chip.description) }}</span>
    <span class="chip-price">
      <span class="p-l-5 p-r-5">R</span>
      <input type="number" class="chip-price-input" [value]="chip.priceOverride"
        (blur)="onPriceBlur(chip, $any($event.target).value)" min="0" step="0.01">
    </span>
    <button matChipRemove [attr.aria-label]="'Remove ' + chip.code">
      <mat-icon>cancel</mat-icon>
    </button>
  </mat-chip-row>
</mat-chip-grid>

<ng-template #priceDialog>
  <h1 mat-dialog-title>Set fixed price (ZAR)</h1>
  <div mat-dialog-content>
    <mat-form-field appearance="outline" class="full-width m-t-10">
      <mat-label>Rate (ZAR)</mat-label>
      <span matPrefix class="p-l-5 p-r-5">R</span>
      <input matInput type="number" [(ngModel)]="priceDialogValue" step="0.01" min="0">
    </mat-form-field>
  </div>
  <div mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="cancelPrice()">Cancel</button>
    <button mat-raised-button color="primary" (click)="confirmPrice()">Save</button>
  </div>
</ng-template>


